"use strict";
exports.__esModule = true;
exports.SET_WALLET_MODULES = exports.UPDATE_ACCOUNT = exports.REMOVE_WALLET = exports.UPDATE_WALLET = exports.ADD_WALLET = exports.RESET_STORE = exports.ADD_CHAINS = void 0;
exports.ADD_CHAINS = 'add_chains';
exports.RESET_STORE = 'reset_store';
exports.ADD_WALLET = 'add_wallet';
exports.UPDATE_WALLET = 'update_wallet';
exports.REMOVE_WALLET = 'remove_wallet';
exports.UPDATE_ACCOUNT = 'update_account';
exports.SET_WALLET_MODULES = 'set_wallet_modules';
